import {
  FolderGit2,
  Factory,
  Rocket,
  Code,
  Terminal,
  Globe,
  Store,
  ShoppingCart,
  Package,
  Boxes,
  Database,
  Server,
  Cloud,
  Cpu,
  Smartphone,
  Monitor,
  LayoutDashboard,
  ChartLine,
  Calculator,
  Wallet,
  Receipt,
  BookOpen,
  FileText,
  Mail,
  MessageSquare,
  Calendar,
  Users,
  Briefcase,
  Building2,
  House,
  Wrench,
  Hammer,
  Bot,
  Brain,
  Sparkles,
  Zap,
  Flame,
  Leaf,
  Heart,
  Star,
  Shield,
  Lock,
  Key,
  Camera,
  Music,
  Gamepad2,
  Truck,
  Plane,
  type LucideIcon,
} from 'lucide-react';
import { DEFAULT_PROJECT_ICON, type ProjectIconName } from '@shared/project-icon';

/** Each project icon's Lucide component (T-25; the names are in @shared/project-icon). */
export const PROJECT_ICON_COMPONENTS: Record<ProjectIconName, LucideIcon> = {
  'folder-git-2': FolderGit2,
  factory: Factory,
  rocket: Rocket,
  code: Code,
  terminal: Terminal,
  globe: Globe,
  store: Store,
  'shopping-cart': ShoppingCart,
  package: Package,
  boxes: Boxes,
  database: Database,
  server: Server,
  cloud: Cloud,
  cpu: Cpu,
  smartphone: Smartphone,
  monitor: Monitor,
  'layout-dashboard': LayoutDashboard,
  'chart-line': ChartLine,
  calculator: Calculator,
  wallet: Wallet,
  receipt: Receipt,
  'book-open': BookOpen,
  'file-text': FileText,
  mail: Mail,
  'message-square': MessageSquare,
  calendar: Calendar,
  users: Users,
  briefcase: Briefcase,
  'building-2': Building2,
  house: House,
  wrench: Wrench,
  hammer: Hammer,
  bot: Bot,
  brain: Brain,
  sparkles: Sparkles,
  zap: Zap,
  flame: Flame,
  leaf: Leaf,
  heart: Heart,
  star: Star,
  shield: Shield,
  lock: Lock,
  key: Key,
  camera: Camera,
  music: Music,
  'gamepad-2': Gamepad2,
  truck: Truck,
  plane: Plane,
};

/** Each icon's name for screen readers and hints in the picker. */
export const PROJECT_ICON_LABELS: Record<ProjectIconName, string> = {
  'folder-git-2': 'Folder git',
  factory: 'Factory',
  rocket: 'Rocket',
  code: 'Code',
  terminal: 'Terminal',
  globe: 'Globe',
  store: 'Store',
  'shopping-cart': 'Shopping cart',
  package: 'Package',
  boxes: 'Boxes',
  database: 'Database',
  server: 'Server',
  cloud: 'Cloud',
  cpu: 'Cpu',
  smartphone: 'Smartphone',
  monitor: 'Monitor',
  'layout-dashboard': 'Layout dashboard',
  'chart-line': 'Chart line',
  calculator: 'Calculator',
  wallet: 'Wallet',
  receipt: 'Receipt',
  'book-open': 'Book open',
  'file-text': 'File text',
  mail: 'Mail',
  'message-square': 'Message square',
  calendar: 'Calendar',
  users: 'Users',
  briefcase: 'Briefcase',
  'building-2': 'Building',
  house: 'House',
  wrench: 'Wrench',
  hammer: 'Hammer',
  bot: 'Bot',
  brain: 'Brain',
  sparkles: 'Sparkles',
  zap: 'Zap',
  flame: 'Flame',
  leaf: 'Leaf',
  heart: 'Heart',
  star: 'Star',
  shield: 'Shield',
  lock: 'Lock',
  key: 'Key',
  camera: 'Camera',
  music: 'Music',
  'gamepad-2': 'Gamepad',
  truck: 'Truck',
  plane: 'Plane',
};

/** A project's icon component; null (never picked) is the default folder. */
export function projectIconComponent(name: ProjectIconName | null | undefined): LucideIcon {
  return PROJECT_ICON_COMPONENTS[name ?? DEFAULT_PROJECT_ICON] ?? PROJECT_ICON_COMPONENTS[DEFAULT_PROJECT_ICON];
}
